import Alpine from 'alpinejs';
import { AppStore } from './app_store';

Alpine.store('appStore', new AppStore());

export const appStore = Alpine.store('appStore') as AppStore;
